import styled from "styled-components";

export const HeaderTitle = styled.div`
  display: flex;
  /* width: 100%; */
  flex-flow: wrap;
  padding: 0px 16px 8px 16px;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid #eee;

  background: #fff;
  color: #333;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
`;
